import clsx from 'clsx';

const classNames = (isFullWidth = false) => {
	return clsx(
		'group min-h-button min-w-button font-button p-[10px]',
		'ring-0 focus:ring-4',
		'disabled:cursor-not-allowed outline-none inline-flex items-center justify-center relative rounded-button transition-all',
		isFullWidth ? 'w-full' : 'w-auto',
	);
};

export default classNames;
